import { useState, useEffect } from 'react';
import { fetchOpportunityTypes, type OpportunityTypeGroup } from '../services/optionsService';

interface Result {
  groups: OpportunityTypeGroup[];
  loading: boolean;
}

export function useOpportunityTypes(lang: string): Result {
  const [state, setState] = useState<Result>({ groups: [], loading: true });

  useEffect(() => {
    let cancelled = false;
    fetchOpportunityTypes(lang)
      .then((data) => {
        if (!cancelled) setState({ groups: data, loading: false });
      })
      .catch(() => {
        if (!cancelled) setState({ groups: [], loading: false });
      });
    return () => {
      cancelled = true;
    };
  }, [lang]);

  return state;
}
